import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { BaseResponse, BaseResponseObj } from 'ccc-commons/dist/core';
import { Account } from './../models/account.model';
import { AccountLicenses } from '../models/accountLicenses';
import {AccountDTO} from '@ccc-core/dtos/account.dto';
import {CoachingAdmin, CoachingAdminWithOrganizations} from '@ccc-core/models/coaching-admin.model';

@Injectable()
export class AccountsService {

  apiUrl = environment.apiUrl + '/accounts';
  orgUrl = environment.apiUrl + '/organizations';

  constructor(private http: HttpClient) { }

  getAccountsWithParam(params) {
    const httpParams = new HttpParams({ fromObject: params });

    return this.http.get<BaseResponse<any>>(`${this.apiUrl}`,
      { params: httpParams });
  }

  getAccountById(accountId) {
    return this.http.get<BaseResponseObj<Account>>(`${this.apiUrl}/${accountId}`);
  }

  addAccount(account: Account): Observable<BaseResponse<Account>> {
    return this.http.post<BaseResponse<Account>>(this.apiUrl, account);
  }

  /**
   * updateAccount
   * save the changes from the account modal
   * @param account
   */
  public updateAccount(account: AccountDTO): Observable<BaseResponse<Account>> {
    return this.http.put<BaseResponse<Account>>(`${this.apiUrl}/${account.id}`, account);
  }

  updateAccountStatus(status, accountId): Observable<any> {
    const statusData = {
      status: status
    };

    return this.http.put(`${this.apiUrl}/${accountId}/status`,
      JSON.stringify(statusData));
  }


  downloadCsvOrganizations(orgId): Observable<BaseResponseObj<any>> {
    return this.http.get(`${this.orgUrl}/${orgId}/export`, { responseType: 'blob', observe: 'response' });
  }

  downloadAccountCvsFile(orgId): Observable<BaseResponseObj<any>> {
    return this.http.get(`${this.orgUrl}/${orgId}/accounts/export`, { responseType: 'blob', observe: 'response' });
  }

  deleteAccount(accountId): Observable<BaseResponseObj<any>> {
    return this.http.delete<BaseResponseObj<any>>(`${this.apiUrl}/${accountId}`);
  }

  getAccountLicenses(accountId, params): Observable<BaseResponse<AccountLicenses>> {
    const httpParams = new HttpParams({fromObject: params});

    return this.http.get<BaseResponse<AccountLicenses>>(`${this.apiUrl}/${accountId}/licenses`,
      {params: httpParams});
  }

  updateAccountLicenses(accountId, data: AccountLicenses[], params) {

    const httpParams = new HttpParams({fromObject: params});

    return this.http.put(`${this.apiUrl}/${accountId}/licenses`, JSON.stringify(data),
      {
        headers: { 'Content-Type': 'application/json' },
        params: httpParams
      });
  }

  updateEmailAccount(idAccount: string, emailAccount: string): Observable<any> {
    const request = {
      email: emailAccount,
    };

    return this.http.put(
      `${this.apiUrl}/${idAccount}/email`,
      JSON.stringify(request),
      {
        headers: { 'Content-Type': 'application/json' },
      }
    );
  }

  /**
   * getCoachingAdmins
   * get the list of coaching admins with the organizations where they are currently assigned
   * @returns `Observable` with the list of coaching admins
   */
  public getCoachingAdmins(): Observable<BaseResponseObj<CoachingAdminWithOrganizations[]>> {
    return this.http.get<BaseResponseObj<CoachingAdminWithOrganizations[]>>(`${this.apiUrl}/coachingAdmins`);
  }
}
